import BaseMenu from '@material-ui/core/Menu'

const Menu = BaseMenu

export default Menu
